import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BrandingService } from '../../../../core/services/branding.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  private guid: string;

  get useChangePasswordForm() {
    return !this.guid;
  }

  get logoPath(): string {
    return this.brandingService.getLogoPath();
  }

  constructor(private activatedRoute: ActivatedRoute, private brandingService: BrandingService) {
      this.activatedRoute.params.subscribe(params => {
        this.guid = params.guid;
      });
    }

  ngOnInit() {
  }

}
